import { useCallback, useMemo } from 'react';
import usePlatformConfig from '../../../common/react/usePlatformConfig';
import IPrice from '../../model/prices/IPrice';

const usePriceValidation = (prices: IPrice[]) => {
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();

  const hasSecondaryCurrency = useCallback(() => !!priceDisplay!.secondary, [priceDisplay]);
  const hasDifferentCurrencies = useCallback(
    () => priceDisplay.primary.currency !== priceDisplay.secondary.currency,
    [priceDisplay],
  );

  const isMultiCurrency = useMemo(() => hasSecondaryCurrency() && hasDifferentCurrencies(), [priceDisplay, prices]);

  return { isMultiCurrency };
};

export default usePriceValidation;
